import TicketsOverview from '../../features/tickets/layouts/overview';

export default function TicketsPage() {
    return <TicketsOverview />;
}
